import { ReactNode } from 'react';
import classNames from 'classnames';
import { cn } from '@/utils/cn';
interface Props {
  percent: number;
  children: ReactNode;
  className?: string;
  mainBarclassName?: string;
  activeBarClassName?: string;
}
export const LineProgressBar = ({
  percent,
  children,
  className,
  mainBarclassName,
  activeBarClassName
}: Props) => {
  return <div className={classNames('flex w-full flex-col', className)} data-sentry-component="LineProgressBar" data-sentry-source-file="line-progress-bar.tsx">
            <div className={cn('h-1 w-full rounded bg-primary-shade-200', mainBarclassName)}>
                <div className={cn('h-1 max-w-full rounded-md bg-primary-main transition-all duration-500', activeBarClassName)} style={{
        width: `${percent}%`
      }}></div>
            </div>
            {children}
        </div>;
};